import React, { useState } from 'react';

import './Copy.scss';
import { IconPaperOutline } from '../Icons';
import { TooltipTrigger } from '../TooltipTrigger/TooltipTrigger';

/*
 * We have to generate dinamically a button to copy all the code in the relative section.
 * The button must be positioned top right to each container of the code.
 * copyToClipboard it's used to copy the code, saving space and indexing.
 */
const copyToClipboard = (content) => {
  const el = document.createElement(`textarea`);
  el.value = content;
  el.setAttribute(`readonly`, ``);
  el.style.position = `absolute`;
  el.style.left = `-9999px`;
  document.body.appendChild(el);
  el.select();
  document.execCommand(`copy`);
  document.body.removeChild(el);
};

const delay = (duration) => new Promise((resolve) => setTimeout(resolve, duration));

interface CopyProps {
  content: string;
  trim?: boolean;
  className?: string;
}

function Copy({ content, trim = false }: CopyProps): React.ReactElement {
  const [copied, setCopied] = useState(false);

  return (
    <div className="copy">
      {/* <div
        onClick={async () => {
          copyToClipboard(trim ? content.trim() : content);
          setCopied(true);
          await delay(5000);
          setCopied(false);
        }}
        className="copy__button"
      >
        {copied ? (
          <>
            <IconPaperOutline /> Copied
          </>
        ) : (
          <>
            <IconPaperOutline />
          </>
        )}
      </div> */}

      <TooltipTrigger
        TriggerElement={
          <div className="copy__button">
            <span className="copy__icon">
              <IconPaperOutline />
            </span>
          </div>
        }
        onClick={async () => {
          copyToClipboard(trim ? content.trim() : content);
          setCopied(true);
          await delay(5000);
          setCopied(false);
        }}
        delay={0}
        tooltipPlacement="left-start"
        tooltipStrategy="absolute"
        tooltipType="tooltip"
        headerClass
      >
        {copied ? 'Copied!' : 'Click to copy'}
      </TooltipTrigger>
    </div>
  );
}

export default Copy;
